import { mapActions, mapMutations, mapGetters, mapStates } from './../baseModule'
import CouchdbClass from '../../services/CouchdbClass'
import connections from '../../config/connections'

const collection = 'projects'
const singleName = 'project'
const pluralName = 'projects'
const connection = 'config'

const Couchdb = new CouchdbClass({ connection: 'config', collection: 'projects' })

const model = {
  projectName: '',
  projectOnlineRegister: '',
  remoteHost: 'https://couch-trg.3e.eng.br/',
  servername: '',
  name: '',
  eventLabel: '',
  requiredNIS: false,
  requiredTermLamp: false,
  defaultWinnerChoiceMode: 'lottery',
  haveSurveys: false,
  viewGoogleMap: false,
  companyTerms: '',
  registerCustomerTicketDocument: false,
  dashboardEduCards: false,
  doc: {
    daysToVisit: '04'
  },
  event: {
    hasCeremony: false,
    automaticReplacement: false,
    customersCanBeRecontemplated: false,
    contemplatedPeriod: 5,
    autoDateOnDeliveryTerm: true,
    hasPhotos: false,
    managedCsv: false
  },
  ticket: {
    automaticBarcode: true
  },
  lamps: {
    max: 0,
    numLedLamps: 0,
    hasSeason: false,
    seasonRange: 12,
    powerLampDeliveryLabel: '8,5'
  },
  register: {
    carrer: false
  },
  validationCustomer: {
    uc: false,
    cpf: false,
    ucOrCpf: false
  },
  validationContemplatedCustomer: {
    uc: false,
    cpf: false
  },
  state: '',
  cities: [],
  company: {
    abbreviation: '',
    longname: '',
    cnpj: '',
    numberState: '',
    address: {
      type: '',
      street: '',
      number: '',
      neighborhood: '',
      city: '',
      state: ''
    }
  }
}
const validations = {
  servername: {
    min: 3
  },
  name: {
    min: 5,
    required: true
  },
  requiredTermLamp: {
    required: true
  },
  requiredNIS: {
    required: true
  },
  event: {
    hasCeremony: { required: true },
    automaticReplacement: { required: true },
    customersCanBeRecontemplated: { required: true },
    contemplatedPeriod: { required: true }
  },
  lamps: {
    max: { required: true },
    numLedLamps: { required: true }
  },
  ticket: {
    automaticBarcode: { required: true }
  },
  state: { required: true },
  validationCustomer: {
    uc: { required: true },
    cpf: { required: true }
  },
  validationContemplatedCustomer: {
    uc: { required: true },
    cpf: { required: true }
  }
}
let getters = {
  ...mapGetters(),
  defaultWinnerChoiceModeOptions: () => Object.assign({
    lottery: 'Sorteio',
    ranking: 'Ranking'
  })
}
getters[singleName] = (state) => {
  return Object.assign({}, model, state.one)
}
getters[pluralName] = (state) => state.all
getters = Object.assign(getters, {
  loading: state => state.loading,
  citiesOptions: (state, getters, rootState) => {
    let cities = []
    const citiesConf = rootState && rootState.config && rootState.config.cities && rootState.config.cities.length > 0 ? rootState.config.cities : state.one && state.one.cities
    for (let city of citiesConf) {
      cities.push({
        value: city,
        label: city
      })
    }
    return cities
  },
  validations: state => state.validations
})
export default {
  namespaced: true,
  state: {
    ...mapStates(),
    model,
    loading: true,
    all: [],
    one: JSON.parse(JSON.stringify(model)),
    validations: validations,
    currentState: '',
    termsByState: {
      AL: ['generic', 'iasc', 'equatorial'],
      CE: ['generic', 'enel'],
      GO: ['generic', 'enel'],
      MA: ['generic', 'cemar', 'iasc'],
      PB: ['generic', 'energisa-borborema', 'energisa-paraiba'],
      PI: ['generic', 'iasc', 'equatorial'],
      PA: ['generic', 'celpa', 'celpa-jurunas']
    },
    urlImages: {
      imgTermLamp: '',
      imgTermLending: '',
      imgTermDelivery: '',
      imgPresenterLeft: '',
      imgPresenterRight: ''
    }
  },
  mutations: {
    ...mapMutations(),
    SET_IMAGES_URL: function (state, payload) {
      state.urlImages = Object.assign(state.urlImages, payload)
    }
  },
  actions: {
    ...mapActions(collection, model, connection),

    uploadFileProject (context, { id, mimeType, name, file }) {
      return Couchdb.insertAttachment(id, {
        mimeType: mimeType,
        attachmentName: name,
        attachment: file
      })
    },

    getImagesProject ({ commit }) {
      const baseURL = `${connections.config.host}/${connections.config.db}/config`
      const datetime = new Date().getTime()
      commit(
        'SET_IMAGES_URL',
        {
          imgTermLamp: `${baseURL}/imgTermLamp?${datetime}`,
          imgTermLending: `${baseURL}/imgTermLending?${datetime}`,
          imgTermDelivery: `${baseURL}/imgTermDelivery?${datetime}`,
          imgPresenterLeft: `${baseURL}/imgPresenterLeft?${datetime}`,
          imgPresenterRight: `${baseURL}/imgPresenterRight?${datetime}`
        }
      )

      return {
        imgTermLamp: `${baseURL}/imgTermLamp?${datetime}`,
        imgTermLending: `${baseURL}/imgTermLending?${datetime}`,
        imgTermDelivery: `${baseURL}/imgTermDelivery?${datetime}`,
        imgPresenterLeft: `${baseURL}/imgPresenterLeft?${datetime}`,
        imgPresenterRight: `${baseURL}/imgPresenterRight?${datetime}`
      }
    }
  },
  getters: {
    ...getters,
    projectsNames: () => {
      return [
        '', // 0
        'efce_', // 1
        'efgo_', // 2
        'eqal2_', // 3
        'eqia_', // 4
        'eqma_', // 5
        'eqpa_', // 6
        'eqpi_', // 7
        'mema_', // 8
        'nepb_', // 9
        'eqal_notiasc_', // 10
        'eqma_notiasc_', // 11
        'eqpi_notiasc_', // 12
        'eqpa_notiasc_', // 13
        'celpa_jurunas_' // 14
      ]
    },
    remoteDatabasesNames: state => {
      return {
        'default': 'admin',
        'states': 'municipios',
        'specifications': 'specifications',
        'winners': 'contemplados',
        'docs': 'docs',
        'logs': 'logs',
        'surveys': 'surveys',
        'surveys_docs': 'surveys_docs',
        'config': 'config'
      }
    },
    termsByState: state => state.termsByState,
    termsOfState: state => state.termsByState.hasOwnProperty(state.one.state) ? state.termsByState[state] : state.termsByState,
    currentState: state => state.currentState,
    currentTerms: state => {
      if (state.one && state.one.state && state.one.state !== '') {
        return state.termsByState.hasOwnProperty(state.one.state) ? state.termsByState[state.one.state] : []
      }
      return state.termsByState.hasOwnProperty(state.currentState) ? state.termsByState[state.currentState] : []
    },

    urlImages: state => {
      const baseURL = `${connections.config.host}/${connections.config.db}/config`
      return {
        imgTermLamp: `${baseURL}/imgTermLamp`,
        imgTermLending: `${baseURL}/imgTermLending`,
        imgTermDelivery: `${baseURL}/imgTermDelivery`,
        imgPresenterLeft: `${baseURL}/imgPresenterLeft`,
        imgPresenterRight: `${baseURL}/imgPresenterRight`
      }
    },
    sidebarLinks: state => {
      let appLinks = [
        {
          name: 'Dashboard',
          icon: 'ti-bar-chart',
          children: [
            {
              name: 'Dashboard',
              path: '/admin/dashboard',
              tag: 'dashboard.overview'
            }
          ]
        },
        {
          name: 'Gerenciar',
          icon: 'ti-view-list-alt',
          collapsed: false,
          children: [
            {
              name: state.one.eventLabel,
              path: '/manage/events',
              tag: 'events.index'
            },
            {
              name: 'Especificações: ' + state.one.eventLabel,
              path: '/manage/eventsSpecifications',
              tag: 'eventsSpecifications.index'
            },
            {
              name: 'Clientes',
              path: '/manage/customers',
              tag: 'customers.index'
            },
            {
              name: 'Tickets',
              path: '/tickets/details',
              tag: 'tickets.details'
            },
            {
              name: 'Estoque',
              path: '/manage/stock',
              tag: 'stock.index'
            },
            {
              name: 'Relatórios',
              path: '/manage/reports',
              tag: 'reports.index'
            },
            {
              name: 'Estado da Replicação',
              path: '/manage/status-replications',
              tag: 'statusReplication.index'
            }
            // {
            //   name: 'Sincronia',
            //   path: '/manage/sync',
            //   tag: 'sync.index'
            // }
          ]
        },
        {
          name: 'Configurações',
          icon: 'ti-panel',
          collapsed: true,
          children: [
            {
              name: 'Usuários',
              path: '/configurations/users',
              tag: 'users.index'
            },
            {
              name: 'Perfis',
              path: '/configurations/roles',
              tag: 'roles.index'
            },
            {
              name: 'Projeto',
              path: '/configurations/project',
              tag: 'project.index'
            },
            {
              name: 'Fabricantes',
              path: '/configurations/manufacturers',
              tag: 'manufacturers.index'
            },
            {
              name: 'Categorias',
              path: '/categories',
              tag: 'categories.index'
            },
            {
              name: 'Tags',
              path: '/configurations/tags',
              tag: 'tags.index'
            },
            {
              name: 'API',
              path: '/configurations/api',
              tag: 'api.index'
            }
          ]
        }
      ]
      const themeLinks = [
        {
          name: 'Dashboard',
          icon: 'ti-panel',
          children: [
            {
              name: 'Overview',
              path: '/admin/overview'
            },
            {
              name: 'Stats',
              path: '/admin/stats'
            }
          ]
        },
        {
          name: 'Components',
          icon: 'ti-package',
          children: [
            {
              name: 'Buttons',
              path: '/components/buttons'
            },
            {
              name: 'Grid System',
              path: '/components/grid-system'
            },
            {
              name: 'Panels',
              path: '/components/panels'
            },
            {
              name: 'Sweet Alert',
              path: '/components/sweet-alert'
            },
            {
              name: 'Notifications',
              path: '/components/notifications'
            },
            {
              name: 'Icons',
              path: '/components/icons'
            },
            {
              name: 'Typography',
              path: '/components/typography'
            }
          ]
        },
        {
          name: 'Forms',
          icon: 'ti-clipboard',
          children: [
            {
              name: 'Regular Forms',
              path: '/forms/regular'
            },
            {
              name: 'Extended Forms',
              path: '/forms/extended'
            },
            {
              name: 'Validation Forms',
              path: '/forms/validation'
            },
            {
              name: 'Wizard',
              path: '/forms/wizard'
            }
          ]
        },
        {
          name: 'Table List',
          icon: 'ti-view-list-alt',
          collapsed: true,
          children: [
            {
              name: 'Regular Tables',
              path: '/table-list/regular'
            },
            {
              name: 'Extended Tables',
              path: '/table-list/extended'
            },
            {
              name: 'Paginated Tables',
              path: '/table-list/paginated'
            }
          ]
        },
        {
          name: 'Maps',
          icon: 'ti-map',
          children: [
            {
              name: 'Google Maps',
              path: '/maps/google'
            },
            {
              name: 'Full Screen Maps',
              path: '/maps/full-screen'
            },
            {
              name: 'Vector Maps',
              path: '/maps/vector-map'
            }
          ]
        },
        {
          name: 'Charts',
          icon: 'ti-gift',
          path: '/charts'
        },
        {
          name: 'Calendar',
          icon: 'ti-calendar',
          path: '/calendar'
        },
        {
          name: 'Pages',
          icon: 'ti-gift',
          children: [
            {
              name: 'User Page',
              path: '/pages/user'
            },
            {
              name: 'Timeline Page',
              path: '/pages/timeline'
            },
            {
              name: 'Login Page',
              path: '/login'
            },
            {
              name: 'Register Page',
              path: '/register'
            },
            {
              name: 'Lock Page',
              path: '/lock'
            }
          ]
        }
      ]
      const includeThemeLinks = false
      if (includeThemeLinks) {
        appLinks = appLinks.concat(themeLinks)
      }
      return appLinks
    },
    eventLabel: state => state.one.eventLabel
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/project.js